/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Thu Apr 15 2021 13:12:14 GMT+0200 (czas środkowoeuropejski letni)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.CLIENT_INVOICE;
export interface CiLateChargeDetail {
  lidid: number;
  calid: number;
  listartdate: string;
  lienddate: string;
  linbdays: number;
  liinterestrate: number;
  libasis: number;
  licalculatedamount: number;
}
export interface CiLateCharge {
  ciLateChargeDetailList: Array<CiLateChargeDetail>;
  calid: number;
  ciid: number;
  tpid: number;
  caldate: string;
  priid: string;
  ratevalue: number;
  calculatedamount: number;
  invoicedamount: number;
  ciidlatecharge: number;
  cilidlatecharge: number;
  flagblockinvoicing: boolean;
  blockingreason: string;
  Jobid: number;
  proctaskid: number;
  cireference: string;
  citype: string;
  cidocdate: string;
  ctrid: number;
  ctreference: string;
  cipaymentdate: string;
  cipaymentmode: string;
  currcode: string;
  cigrosstotal: number;
  cidueamount: number;
  lctype: string;
}

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}
export interface BatchJobExecution {
  create_time: string;
  end_time: string;
  errorfile: string;
  exit_code: string;
  exit_message: string;
  job_configuration_location: string;
  job_execution_id: number;
  job_instance_id: number;
  last_updated: string;
  logfile: string;
  logfolder: string;
  outputfile: string;
  outputfolder: string;
  serviceexecparam: string;
  servicename: string;
  start_time: string;
  status: string;
  userid: number;
  version: number;
  module: string;
}
export interface PrefinelementResponse {
  ctedescription: string;
  ctefinancedamount: number;
  cteid: number;
  ctrid: number;
  lastCalDate: string;
  prefinbasis: string;
  prefinbasislabel: string;
  prefinmethod: string;
  prefinmethodlabel: string;
  totalDisbursed: number;
  totalInterestCalculated: number;
  totalInvoiced: number;
  rvAmount: number;
  rentalAmount: number;
  curcode: string;
}
export interface CIListResponse {
  cidocdate: string;
  cidocreference: string;
  cidueamount: number;
  cigrosstotal: number;
  ciid: number;
  ciidcreditnote: number;
  ciinvoicetype: string;
  cirefcreditnote: string;
  cireference: string;
  cistatus: string;
  cistatuslabel: string;
  citype: string;
  citypelabel: string;
  clientname: string;
  ctreference: string;
  currcode: string;
  mgid: number;
  tpreference: string;
  printid: number;
  printidemail: number;
}

export interface CIScheduleListResponse {
  cidocdate: string;
  cidocreference: string;
  cidueamount: number;
  cigrosstotal: number;
  ciid: number;
  ciidcreditnote: number;
  cirefcreditnote: string;
  cireference: string;
  cisamount: number;
  cisdueamount: number;
  cisduedate: string;
  cisid: number;
  cisorder: number;
  cispaymentmode: string;
  cisstatus: string;
  cistatus: string;
  cistatuslabel: string;
  cistype: string;
  citype: string;
  citypelabel: string;
  clientname: string;
  ctreference: string;
  currcode: string;
  mgid: number;
  tpidpayer: number;
  tpreference: string;
}

export interface ClientInvoiceLineRequest {
  ciamortizedamount: number;
  ciidinvoicedfees: number;
  ciidlateinterestfees: number;
  cilcategory: string;
  cildescription: string;
  cildescription2: string;
  cilgrossamount: number;
  cilid: number;
  cilinterestamount: number;
  cilnetamount: number;
  cilorder: number;
  ciltaxamount: number;
  ciltaxcode: string;
  ciltaxrate: number;
  ciltype: string;
  ctrid: number;
  psid: number;
  psorder: number;
}

export interface ClientInvoiceLineResponse {
  ciamortizedamount: number;
  ciidinvoicedfees: number;
  ciidlateinterestfees: number;
  cilcategory: string;
  cildescription: string;
  cildescription2: string;
  cilgrossamount: number;
  cilid: number;
  cilinterestamount: number;
  cilnetamount: number;
  cilorder: number;
  ciltaxamount: number;
  ciltaxcode: string;
  ciltaxrate: number;
  ciltype: string;
  ctreference: string;
  ctrid: number;
  psid: number;
  psorder: number;
}

export interface ClientInvoiceRequest {
  accountingdate: string;
  accountingreference: string;
  amortizedamount: number;
  cidocdate: string;
  cidocreference: string;
  cidueamount: number;
  cigrosstotal: number;
  ciid: number;
  ciidcreditnote: number;
  ciidinvoicelateinterest: number;
  ciidinvoicerejectfees: number;
  ciinvoicetype: string;
  cilateinterestcalculatedamount: number;
  cilateinterestcalculateddate: string;
  cilateinterestinvoicedamount: number;
  cimultiplecontracts: boolean;
  cinettotal: number;
  cipaymentdate: string;
  cipaymentdelaycode: string;
  cipaymentmode: string;
  cireference: string;
  cirejected: boolean;
  cirejecteddate: string;
  cirejectedfeesinvoicedamount: number;
  cirejectfeesamount: number;
  cistatus: string;
  citaxtotal: number;
  citype: string;
  clientInvoiceLines: Array<ClientInvoiceLineRequest>;
  clientInvoiceSchedules: Array<ClientInvoiceScheduleRequest>;
  ctreference: string;
  ctrid: number;
  currcode: string;
  interestamount: number;
  jobid: number;
  mgid: number;
  psid: number;
  psorder: number;
  tpidclient: number;
  tpinvoicingaddress: string;
  tpinvoicingaddress2: string;
  tpinvoicingcity: string;
  tpinvoicingregion: string;
  tpinvoicingzipcode: string;
}

export interface ClientInvoiceResponse {
  accountingdate: string;
  accountingreference: string;
  amortizedamount: number;
  assetcategory: string;
  assetcategorylabel: string;
  assettype: string;
  assettypelabel: string;
  bouseremail: string;
  bousername: string;
  bousertel: string;
  cidocdate: string;
  cidocdatecreditnote: string;
  cidocreference: string;
  cidueamount: number;
  cigrosstotal: number;
  ciid: number;
  ciidcreditnote: number;
  ciidinvoicelateinterest: number;
  ciidinvoicerejectfees: number;
  ciinvoicetype: string;
  ciinvoicetypelabel: string;
  cilateinterestcalculatedamount: number;
  cilateinterestcalculateddate: string;
  cilateinterestinvoicedamount: number;
  cilineadditionaltext: string;
  cimultiplecontracts: boolean;
  cinettotal: number;
  cipaymentdate: string;
  cipaymentdelaycode: string;
  cipaymentmode: string;
  cireference: string;
  cirejected: boolean;
  cirejecteddate: string;
  cirejectedfeesinvoicedamount: number;
  cirejectfeesamount: number;
  cispecificcondition: string;
  cistatus: string;
  citaxtotal: number;
  citype: string;
  citypelabel: string;
  clientInvoiceLines: Array<ClientInvoiceLineResponse>;
  clientInvoiceSchedules: Array<ClientInvoiceScheduleResponse>;
  clientname: string;
  clientreference: string;
  clientsurname: string;
  contractname: string;
  created_at: string;
  created_atcreditnote: string;
  created_by: number;
  ctinvoicesendingmode: string;
  ctinvoicingmode: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  flagPrinted: boolean;
  flagemail: boolean;
  interestamount: number;
  jobid: number;
  jobidemail: number;
  jobidprint: number;
  mgid: number;
  printid:number;
  psduration: number;
  psid: number;
  psorder: number;
  recuseremail: string;
  recusername: string;
  recusertel: string;
  refinvoicecreditnote: string;
  refinvoicelateinterest: string;
  refinvoicerejectfees: string;
  saleuseremail: string;
  saleusername: string;
  saleusertel: string;
  statuslabel: string;
  tpcontactname: string;
  tpemail1: string;
  tpfiscalid: string;
  tpidclient: number;
  tpinvoicingaddress: string;
  tpinvoicingaddress2: string;
  tpinvoicingcity: string;
  tpinvoicingregion: string;
  tpinvoicingzipcode: string;
  tplegalform: string;
  tpmanagername: string;
  tpsalutationcode: string;
  tpsalutationcodelabel: string;
  tptaxid: string;
  tptel1: string;
  tptelmobile1: string;
  updated_at: string;
  updated_by: number;
}

export interface ClientInvoiceScheduleRequest {
  cisamount: number;
  cisdueamount: number;
  cisduedate: string;
  cisid: number;
  cisorder: number;
  cispaymentdelaycode: string;
  cispaymentmode: string;
  cisstatus: string;
  cistype: string;
  mgbankaccount: number;
  tpidpayer: number;
  tpbkid: number;
  tppayerbankaccount: string;
}

export interface ClientInvoiceScheduleResponse {
  cisamount: number;
  cisdueamount: number;
  cisduedate: string;
  cisid: number;
  cisorder: number;
  cispaymentdelaycode: string;
  cispaymentmode: string;
  cisstatus: string;
  cistype: string;
  mgbankaccount: number;
  tpidpayer: number;
  tpbkid: number;
  tppayerbankaccount: string;
}

export interface File {
  absolute: boolean;
  absoluteFile: File;
  absolutePath: string;
  canonicalFile: File;
  canonicalPath: string;
  directory: boolean;
  file: boolean;
  freeSpace: number;
  hidden: boolean;
  name: string;
  parent: string;
  parentFile: File;
  path: string;
  totalSpace: number;
  usableSpace: number;
}

export interface InputStream {}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface MGCompany {
  countcode: string;
  lancode: string;
  mgbankissuer: string;
  mgcapital: string;
  mgemail: string;
  mgfiscalcity: string;
  mgfiscalid: string;
  mgfree1: string;
  mgfree2: string;
  mgfree3: string;
  mgfree4: string;
  mgfree5: string;
  mgid: number;
  mglegalform: string;
  mgmainadrcity: string;
  mgmainadrcountry: string;
  mgmainadrregion: string;
  mgmainadrstreet1: string;
  mgmainadrstreet2: string;
  mgmainadrzipcode: string;
  mgmarketingname: string;
  mgname: string;
  mgreference: string;
  mgsignatoryname: string;
  mgsignatoryposition: string;
  mgsocialmedia: string;
  mgtaxid: string;
  mgtaxmode: string;
  mgtel1: string;
  mgtel2: string;
  mgwebsite: string;
}

export interface ParFunctionLabel {
  funcode: string;
  funlabel: string;
  funmodule: string;
  lancode: string;
}

export interface Resource {
  description: string;
  file: File;
  filename: string;
  inputStream: InputStream;
  open: boolean;
  readable: boolean;
  uri: URI;
  url: URL_Type;
}

export interface URI {
  absolute: boolean;
  authority: string;
  fragment: string;
  host: string;
  opaque: boolean;
  path: string;
  port: number;
  query: string;
  rawAuthority: string;
  rawFragment: string;
  rawPath: string;
  rawQuery: string;
  rawSchemeSpecificPart: string;
  rawUserInfo: string;
  scheme: string;
  schemeSpecificPart: string;
  userInfo: string;
}

export interface URL_Type {
  authority: string;
  content: {};
  defaultPort: number;
  file: string;
  host: string;
  path: string;
  port: number;
  protocol: string;
  query: string;
  ref: string;
  userInfo: string;
}

export interface GenInvoiceFeesParams {
  amountToInvoice?: number;
  ctetype: string;
  entity: string;
  entityid: number;
  entitytarget: string;
  entitytaskidtarget: number;
  kafkaenabled?: string;
  priid?: string;
  notifid?: string;
}

export interface CiPrefinInterestDetail {
  lidid: number;
  cteid: number;
  siid: number;
  payid: number;
  assetid: number;
  compid: number;
  libasis: number;

  listartdate: string;
  lienddate: string;
  linbdays: number;

  prefinrateref: number;
  prefinratespread: number;
  prefinnominalrate: number;
  licalculatedamount: number;
}

export interface CiPrefinInterest {
  ciPrefinInterestDetailList: Array<CiPrefinInterestDetail>;
  calid: number;
  ctrid: number;
  cteid: number;
   tpidclient: number;
	 calcdate:string;
	 duedate:string;
	 prefinmethod:string;
	 prefinbasis:string;
	 prefinperiodicity:string;
	 prefinratetype:string;
	 prefinrateformula:string;
	
	 calculatedamount:number;
	 invoicedamount:number;
	 ciid:number;
	 cilid:number;
	 Jobid:number;
	 proctaskid:number;
	 lctype:string;
   ctreference:string;
   ctedescription:string;
}


export interface CiLateChargeResponse {
  blockingreason: string;
  calculatedamount: number;
  caldate: string;
  calid: number;
  ciLateChargeDetailList: Array<CiLateChargeDetail>;
  cidocdate: string;
  cidueamount: number;
  cigrosstotal: number;
  ciid: number;
  ciidlatecharge: number;
  cilatechargereference: string;
  cilidlatecharge: number;
  cipaymentdate: string;
  cipaymentmode: string;
  cireference: string;
  citype: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  flagblockinvoicing: boolean;
  invoicedamount: number;
  invoicetypelabel: string;
  jobid: number;
  lctype: string;
  priid: number;
  proctaskid: number;
  ratevalue: number;
  tpid: number;
}









/**
 * @tags Client Invoice Controller
 * @summary genInvoiceFees
 */
export function genInvoiceFees(params: GenInvoiceFeesParams) {
  return request.post<AbstractResponse<ClientInvoiceResponse, object>>(
    `${URL}/api/clientInvoice/run/invoiceFees` +
      prepareQueryParams({
        amountToInvoice: params.amountToInvoice,
        ctetype: params.ctetype,
        entity: params.entity,
        entityid: params.entityid,
        entitytarget: params.entitytarget,
        entitytaskidtarget: params.entitytaskidtarget,
        kafkaenabled: params.kafkaenabled,
        priid: params.priid,
        notifid: params.notifid,
      } as any)
  );
}
export interface FindCIByAnyRefOrStatusOrDateParams {
  cidocreference: string;
  cireference: string;
  cistatus: string;
  citype: string;
  clientname: string;
  ctreference: string;
  datemax: string;
  datemin: string;
  mgid: number;
  paystatus: string;
  tpreference: string;
  currcode: string;
}

/**
 * @tags Client Invoice Controller
 * @summary findCIByAnyRefOrStatusOrDate
 */
export function findCIByAnyRefOrStatusOrDate(
  params: FindCIByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, CIListResponse>>(
    `${URL}/api/clientInvoice` +
      prepareQueryParams({
        cidocreference: params.cidocreference,
        cireference: params.cireference,
        cistatus: params.cistatus,
        citype: params.citype,
        clientname: params.clientname,
        ctreference: params.ctreference,
        datemax: params.datemax,
        datemin: params.datemin,
        mgid: params.mgid,
        paystatus: params.paystatus,
        tpreference: params.tpreference,
        currcode: params.currcode,
      } as any)
  );
}

export interface CreateClientInvoiceParams {
  clientInvoiceRequest: ClientInvoiceRequest;
  jobid?: number;
}

/**
 * @tags Client Invoice Controller
 * @summary createClientInvoice
 */
export function createClientInvoice(params: CreateClientInvoiceParams) {
  return request.post<AbstractResponse<ClientInvoiceResponse, object>>(
    `${URL}/api/clientInvoice` +
      prepareQueryParams({ jobid: params.jobid } as any),
    params.clientInvoiceRequest
  );
}

export interface CreateCreditNoteEvollisParams {
  ciid: number;
  jobid?: number;
  psid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary createCreditNoteEvollis
 */
export function createCreditNoteEvollis(params: CreateCreditNoteEvollisParams) {
  return request.put<string>(
    `${URL}/api/clientInvoice/Evollis/${params.ciid}/createCreditNote` +
      prepareQueryParams({ jobid: params.jobid, psid: params.psid } as any)
  );
}

export interface CreateCreditNoteForCanceledInstallmentEvollisParams {
  ciid: number;
  jobid?: number;
  psid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary createCreditNoteForCanceledInstallmentEvollis
 */
export function createCreditNoteForCanceledInstallmentEvollis(
  params: CreateCreditNoteForCanceledInstallmentEvollisParams
) {
  return request.put<string>(
    `${URL}/api/clientInvoice/Evollis/${params.ciid}/createCreditNoteForCanceledInstallment` +
      prepareQueryParams({ jobid: params.jobid, psid: params.psid } as any)
  );
}

export interface GetListDetailedCIParams {
  cirefend: string;
  cirefstart: string;
  groupingLines?: string;
  jobid: number;
  mgid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary getListDetailedCI
 */
export function getListDetailedCI(params: GetListDetailedCIParams) {
  return request.get<AbstractResponse<MGCompany, ClientInvoiceResponse>>(
    `${URL}/api/clientInvoice/printingFlow` +
      prepareQueryParams({
        cirefend: params.cirefend,
        cirefstart: params.cirefstart,
        groupingLines: params.groupingLines,
        jobid: params.jobid,
        mgid: params.mgid,
      } as any)
  );
}

export interface GenEvollisClientInvoiceByContractParams {
  Authorization?: string;
  ctridend: number;
  ctridstart: number;
  duedate: string;
  mode: string;
}

export interface GenClientInvoiceByContractParams {
  Authorization?: string;
  ctridend: number;
  ctridstart: number;
  duedate: string;
  mode: string;
  mgid:number;
}

export interface CalculateLateChargeParams {
  tpidend: number;
  tpidstart: number;
  calcdate: string;
}

export interface GenLateChargeInvoiceParams {
  tpidend: number;
  tpidstart: number;
}

export interface CalculateLateChargeByTpidParams {
  tpid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary genEvollisClientInvoiceByContract
 */
export function genEvollisClientInvoiceByContract(
  params: GenEvollisClientInvoiceByContractParams
) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/clientInvoice/run/evollis` +
      prepareQueryParams({
        ctridend: params.ctridend,
        ctridstart: params.ctridstart,
        duedate: params.duedate,
        mode: params.mode,
      } as any)
  );
}

export function genClientInvoiceByContract(
  params: GenClientInvoiceByContractParams
) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/clientInvoice/run/scheduledPayment` +
      prepareQueryParams({
        ctridend: params.ctridend,
        ctridstart: params.ctridstart,
        duedate: params.duedate,
        mode: params.mode,
        mgid: params.mgid
      } as any)
  );
}

export function calculateLateCharge(params: CalculateLateChargeParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/lateCharge/run/calculate` +
      prepareQueryParams({
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
        calcdate: params.calcdate,
      } as any)
  );
}

export function genLateChargeInvoice(params: GenLateChargeInvoiceParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/lateCharge/run/invoice` +
      prepareQueryParams({
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
      } as any)
  );
}

export interface UpdateInvoiceLateCalculationStatusParams {
  tpid: number;
  calid: number;
  flagblockinvoicing: boolean;
  blockingreason: string;
}

export function calculateLateChargeByTpid(
  params: CalculateLateChargeByTpidParams
) {
  return request.put<AbstractResponse<object, CiLateCharge>>(
    `${URL}/api/lateCharge/calculate/${params.tpid}`
  );
}

export function updateInvoiceLateCalculationStatus(
  params: UpdateInvoiceLateCalculationStatusParams
) {
  return request.put<AbstractResponse<object, CiLateCharge>>(
    `${URL}/api/lateCharge/${params.tpid}/${params.calid}/${params.flagblockinvoicing}/${params.blockingreason}`
  );
}

export interface GenLateChargeInvoiceBytpidParams {
  tpid: number;
  calidList: Array<number>;
  mode: string;
  amountToInvoice: number;
  jobid: number;
}

export function genLateChargeInvoiceBytpid(
  params: GenLateChargeInvoiceBytpidParams
) {
  return request.post<AbstractResponse<object, CiLateCharge>>(
    `${URL}/api/lateCharge/invoice` +
      prepareQueryParams({
        tpid: params.tpid,
        mode: params.mode,
        jobid: params.jobid,
        amountToInvoice: params.amountToInvoice,
      } as any),
    params.calidList
  );
}

export interface GetLateChargeByTpidParams {
  tpid: number;
}

export function getLateChargeByTpid(params: GetLateChargeByTpidParams) {
  return request.get<AbstractResponse<object, CiLateCharge>>(
    `${URL}/api/lateCharge/${params.tpid}`
  );
}

export interface GetClientInvoiceByIdParams {
  ciid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary getClientInvoiceById
 */
export function getClientInvoiceById(params: GetClientInvoiceByIdParams) {
  return request.get<AbstractResponse<ClientInvoiceResponse, object>>(
    `${URL}/api/clientInvoice/${params.ciid}`
  );
}

export interface UpdateClientInvoiceParams {
  ciid: number;
  clientInvoiceRequest: ClientInvoiceRequest;
}

/**
 * @tags Client Invoice Controller
 * @summary updateClientInvoice
 */
export function updateClientInvoice(params: UpdateClientInvoiceParams) {
  return request.put<AbstractResponse<ClientInvoiceResponse, object>>(
    `${URL}/api/clientInvoice/${params.ciid}`,
    params.clientInvoiceRequest
  );
}

export interface GenCreditNoteParams {
  ciid: number;
  jobid?: number;
}

/**
 * @tags Client Invoice Controller
 * @summary genCreditNote
 */
export function genCreditNote(params: GenCreditNoteParams) {
  return request.put<AbstractResponse<ClientInvoiceResponse, object>>(
    `${URL}/api/clientInvoice/${params.ciid}/createCreditNote` +
      prepareQueryParams({ jobid: params.jobid } as any)
  );
}

export interface UpdateClientInvoiceStatusParams {
  ciid: number;
  cistatus: string;
}

/**
 * @tags Client Invoice Controller
 * @summary updateClientInvoiceStatus
 */
export function updateClientInvoiceStatus(
  params: UpdateClientInvoiceStatusParams
) {
  return request.put<AbstractResponse<ClientInvoiceResponse, object>>(
    `${URL}/api/clientInvoice/${params.ciid}/updateStatus/${params.cistatus}`
  );
}

export interface FindCIScheduleByAnyRefOrStatusOrDateParams {
  cidocreference: string;
  cireference: string;
  cisstatus: string;
  cistype: string;
  clientname: string;
  ctreference: string;
  currcode: string;
  datemax: string;
  datemin: string;
  mgid: number;
  paystatus: string;
  tpreference: string;
  tpid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary findCIScheduleByAnyRefOrStatusOrDate
 */
export function findCIScheduleByAnyRefOrStatusOrDate(
  params: FindCIScheduleByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, CIScheduleListResponse>>(
    `${URL}/api/clientInvoiceSchedule` +
      prepareQueryParams({
        cidocreference: params.cidocreference,
        cireference: params.cireference,
        cisstatus: params.cisstatus,
        cistype: params.cistype,
        clientname: params.clientname,
        ctreference: params.ctreference,
        datemax: params.datemax,
        datemin: params.datemin,
        mgid: params.mgid,
        paystatus: params.paystatus,
        currcode: params.currcode,
        tpreference: params.tpreference,
        tpid: params.tpid,
      } as any)
  );
}

export interface GetJobListByCriteriaParams {
  servicename: string;
  startdate: string;
  status: string;
  module: string;
}

/**
 * @tags Batch Job Execution Controller
 * @summary getJobListByCriteria
 */
export function getJobListByCriteriaClientInvoice(
  params: GetJobListByCriteriaParams
) {
  return request.get<AbstractResponse<object, BatchJobExecution>>(
    `${URL}/api/job` +
      prepareQueryParams({
        servicename: params.servicename,
        startdate: params.startdate,
        status: params.status,
      } as any)
  );
}

export interface DownloadFileParams {
  filetype: string;
  jobid: number;
}

/**
 * @tags Batch Job Execution Controller
 * @summary downloadFile
 */
export function downloadFile(params: DownloadFileParams) {
  return request.get<Resource>(
    `${URL}/api/job/download` +
      prepareQueryParams({
        filetype: params.filetype,
        jobid: params.jobid,
      } as any)
  );
}

export interface CalculatePrefinInterestParams {
  activationdate?: string;
  calcdate: string;
  ctridend: number;
  ctridstart: number;
}

/**
 * @tags Client Invoice Controller
 * @summary calculatePrefinInterest
 */
export function calculatePrefinInterest(params: CalculatePrefinInterestParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/prefinInterest/run/calculate` +
      prepareQueryParams({
        activationdate: params.activationdate,
        calcdate: params.calcdate,
        ctridend: params.ctridend,
        ctridstart: params.ctridstart,
      } as any)
  );
}

export interface GetModuleServiceListParams {
  module: string;
}

export interface GetFinContractPrefinElementListParams {
  ctrid: number;
}
/**
 * @tags Client Invoice Controller
 * @summary getFinContractPrefinElementList
 */
export function getFinContractPrefinElementList(
  params: GetFinContractPrefinElementListParams
) {
  return request.get<AbstractResponse<object, PrefinelementResponse>>(
    `${URL}/api/prefinInterest/${params.ctrid}`
  );
}
/**
 * @tags Batch Job Execution Controller
 * @summary getModuleServiceList
 */
export function getModuleServiceList(params: GetModuleServiceListParams) {
  return request.get<AbstractResponse<object, ParFunctionLabel>>(
    `${URL}/api/service/list` +
      prepareQueryParams({ module: params.module } as any)
  );
}
export interface CalculatePrefinInterestByContractElementParams {
  activationDate: string;
  ctreid: number;
  ctrid: number;
  mode: string;
}

/**
 * @tags Client Invoice Controller
 * @summary calculatePrefinInterestByContractElement
 */
export function calculatePrefinInterestByContractElement(
  params: CalculatePrefinInterestByContractElementParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/prefinInterest/calculatePrefinInterestByContractElement` +
      prepareQueryParams({
        activationDate: params.activationDate,
        ctreid: params.ctreid,
        ctrid: params.ctrid,
        mode: params.mode,
      } as any)
  );
}



export interface CalculatePrefinInterestByContractParams {
  calculationDate: string;
  ctrid: number;
  mode: string;
  jobid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary calculatePrefinInterestByContract
 */
export function calculatePrefinInterestByContract(
  params: CalculatePrefinInterestByContractParams
) {
  return request.get<AbstractResponse<object, object>>(
    `${URL}/api/calculatePrefinInterest/${params.ctrid}` +
      prepareQueryParams({
        calculationDate: params.calculationDate,
        mode: params.mode,
        jobid: params.jobid,
        ctrid: params.ctrid,
      } as any)
  );
}


/**
 * @tags Client Invoice Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}
export interface GetLateChargeByCiidParams {
  ciid: number;
}

/**
 * @tags Client Invoice Controller
 * @summary getLateChargeByCiid
 */
export function getLateChargeByCiid(params: GetLateChargeByCiidParams) {
  return request.get<AbstractResponse<object, CiLateChargeResponse>>(
    `${URL}/api/lateChargeByCiid/${params.ciid}`
  );
}

export function getPrefinInterestByCiid(params: GetLateChargeByCiidParams) {
  return request.get<AbstractResponse<object, CiPrefinInterest>>(
    `${URL}/api/prefinInterestByCiid/${params.ciid}`
  );
}



export interface FinConElemSchVariableRate {
  calcid:number;
  ctrid:number;
  ctsid:number;
  cteid:number;
  rateformula:string;
  ratetype:string;
  ratevalue:number;
  calcstartdate:string;
  calcenddate:string;
  nbcalcdays:number;
  calcbasis:string;
  amountbasis:number;
  interestcalcamount:number;
  jobid:number;
  ciid:number;
  cireference:string;
  Jobstatusdate:string;
}




export interface FinConElemSchVariableRateDetail {
  calcdetailid:number;
  calcid:number;
  calcdetailstartdate:string;
  calcdetailenddate:string;
  calcdetailnbdays:number;
  ratevalueref:number;
  ratespread:number;
  calcinterestrate:number;
  calcbasis:string;
  amountbasis:number;
  interestamount:number;
}


/**
 * @tags Client Invoice Controller
 * @summary getVarInterest 
 */
export function getVarInterestByCiid(params: GetLateChargeByCiidParams) {
  return request.get<AbstractResponse<object, FinConElemSchVariableRate>>(
    `${URL}/api/varInterestRate/${params.ciid}`
  );
}

export function getVarInterestDetailByCalcId(params: GetLateChargeByCiidParams) {
  return request.get<AbstractResponse<object, FinConElemSchVariableRateDetail>>(
    `${URL}/api/varInterestRateDetail/${params.ciid}`
  );
}
